import { ReconcileMethod } from '@generated/graphql';

const RECONCILE_METHOD_LABELS: Record<string, string> = {
  [ReconcileMethod.AutoMatch]: 'Auto',
  [ReconcileMethod.Dismissed]: 'Dismissed',
  FORCE: 'Dismissed',
  DE_MINIMIS: 'De Minimis',
};

export const reconcileMethodLabel = (
  method: string | null | undefined,
): string => {
  if (!method) {
    return '—';
  }
  return RECONCILE_METHOD_LABELS[method] ?? '—';
};
